export function humanByteSize(size = 0): string {
  if (size >= 1024 * 1024) return `${Math.floor(size / (1024 * 1024))} MB`;
  if (size >= 1024) return `${Math.floor(size / 1024)} KB`;
  return `${size} B`;
}

export function arrayBufferToBase64(buffer: ArrayBuffer): string {
  let binary = '';
  const bytes = new Uint8Array(buffer);
  for (let i = 0; i < bytes.byteLength; i += 1) {
    binary += String.fromCharCode(bytes[i]!);
  }
  return btoa(binary);
}
